import { Link } from 'react-router-dom';
import I18n from '../../../config/i18n';

import './FooterNavigation.css';
import { onClickShowConsentScreenHandler } from '../../../features/consentManager/tagHelpers';

interface NavigationSection {
  title: string;
  items: NavigationItem[];
}

interface NavigationItem {
  label: string;
  uri: string;
  inApp: boolean;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

export default function FooterNavigation(): JSX.Element {
  const navigationSections: NavigationSection[] = [
    {
      title: I18n.t('footer.support'),
      items: [
        {
          label: I18n.t('shared.footer.faq'),
          uri: `/${I18n.locale}/about/faq`,
          inApp: false,
        },
        {
          label: I18n.t('footer.house_rules'),
          uri: I18n.t('footer.house_rules_link'),
          inApp: false,
        },
        {
          label: I18n.t('shared.footer.breakfast'),
          uri: I18n.t('shared.footer.breakfast_url'),
          inApp: false,
        },
        {
          label: I18n.t('shared.service_navigation.vouchers'),
          uri: I18n.t('shared.service_navigation.vouchers_url'),
          inApp: false,
        },
        {
          label: I18n.t('shared.footer.contact'),
          uri: 'mailto:info@casapilot.com?subject=www.casapilot.com',
          inApp: false,
        },
      ],
    },
    {
      title: I18n.t('shared.footer.hosts'),
      items: [
        {
          label: I18n.t('shared.footer.hosts'),
          uri: `/${I18n.locale}/about/owners`,
          inApp: false,
        },
        {
          label: I18n.t('shared.service_navigation.user.sign_up'),
          uri: `/${I18n.locale}/users/register`,
          inApp: false,
        },
      ],
    },
    {
      title: I18n.t('footer.about'),
      items: [
        {
          label: I18n.t('footer.team_cpl'),
          uri: `/${I18n.locale}/about/team`,
          inApp: false,
        },
        {
          label: I18n.t('footer.casapilot_story'),
          uri: `/${I18n.locale}/about/story-casapilot`,
          inApp: false,
        },
        {
          label: I18n.t('shared.footer.partners'),
          uri: `/${I18n.locale}/partners`,
          inApp: false,
        },
        {
          label: I18n.t('shared.footer.jobs'),
          uri: `/${I18n.locale}/jobs`,
          inApp: false,
        },
        {
          label: I18n.t('shared.footer.imprint'),
          uri: `/${I18n.locale}/about/imprint`,
          inApp: false,
        },
        {
          label: I18n.t('shared.footer.privacy'),
          uri: `/${I18n.locale}/about/privacy`,
          inApp: false,
        },
        {
          label: I18n.t('shared.footer.cookie_settings'),
          uri: '#',
          inApp: true,
          onClick: onClickShowConsentScreenHandler,
        },
      ],
    },
  ];

  return (
    <div className="footer-navigation">
      <nav>
        {navigationSections.map((section) => (
          <div key={section.title} className="footer-navigation__section">
            <h2>{section.title}</h2>
            <ol>
              {section.items.map((item) => (
                <li key={`${item.uri}-${item.label}`}>
                  {item.inApp ? (
                    <Link to={item.uri} onClick={item.onClick}>
                      {item.label}
                    </Link>
                  ) : (
                    <a href={item.uri} onClick={item.onClick}>
                      {item.label}
                    </a>
                  )}
                </li>
              ))}
            </ol>
          </div>
        ))}
        <div />
        <div />
      </nav>

      <div className="footer-navigation__copyright">
        &#169; Casapilot 2010–{new Date().getFullYear()}. All rights reserved.
      </div>
    </div>
  );
}
